import { crmApiInstance } from './client.js';

export const followUpCallsApi = {
  getAll:  (params = {}) => crmApiInstance.get('/follow-up-calls', { params }).then(r => r.data),
  getById: (id)          => crmApiInstance.get(`/follow-up-calls/${id}`).then(r => r.data),
  create:  (payload)     => crmApiInstance.post('/follow-up-calls', payload).then(r => r.data),
  update:  (id, payload) => crmApiInstance.put(`/follow-up-calls/${id}`, payload).then(r => r.data),
  remove:  (id)          => crmApiInstance.delete(`/follow-up-calls/${id}`).then(r => r.data),
};
